import React from 'react';
import c from 'classnames';
import intl from 'react-intl-universal';

import { NextImage } from '@/components/public';
import { useVideoPlayers } from '@/hooks';

import styles from './index.module.less';
import { tabsMap } from '../const';
import { MediaList } from './components';
import type { ContactUSProps } from '../type';

function Index(props: ContactUSProps) {
    const { noDataRender, richTextContent, tabIndex, tabChange } = props;

    /** 视频插件 */
    useVideoPlayers({ dependency: [richTextContent] });

    return (
        <div className={styles.wrapper} id="video-warpper">
            <div className={styles.header__wrapper}>
                <div className={styles.header}>
                    <NextImage
                        src="/logo/contactUS-logo.webp"
                        needPrefix
                        layout="fill"
                        objectFit="contain"
                        alt="HawkInsight"
                    />
                </div>
                <div className={styles.tabs}>
                    {tabsMap.map((item, index) => {
                        const { icon, title, titleMts, key } = item;
                        return (
                            <div
                                onClick={() => tabChange(index)}
                                key={key}
                                className={c(styles.tabs__item, { [styles.active]: tabIndex === index })}
                            >
                                <span className={c('iconfont', icon, styles.tabs__icon)} />
                                <span className={styles.tabs__text}>{intl.get(titleMts).d(title)}</span>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className={styles.content__wrapper}>
                {/* 富文本内容 */}
                {[0, 2].includes(tabIndex) && (
                    <div className={styles.content} dangerouslySetInnerHTML={{ __html: richTextContent }} />
                )}
                {/* 媒体列表 */}
                {[1].includes(tabIndex) && <MediaList noDataRender={noDataRender} />}
                {noDataRender()}
            </div>
        </div>
    );
}

export default Index;
